<template>
  <footer id="footer">
    <!-- 友情链接区域 - 高级感设计 -->
    <div class="head-container">
      <div class="section-wrapper">
        <div class="section-header">
          <span class="section-subtitle">Partners</span>
          <h3 class="section-title">伍號酒店欢迎您<br>开启更多精彩</h3>
          <div class="divider">
            <span class="divider-line"></span>
            <span class="divider-icon">✦</span>
            <span class="divider-line"></span>
          </div>
        </div>

        <!-- 桌面端网格布局 -->
        <div class="connect-container desktop-view">
          <div
            class="web-box"
            v-for="(item, index) in logoData"
            :key="index"
            @mouseenter="handleLogoHover(index, true)"
            @mouseleave="handleLogoHover(index, false)"
          >
            <a :href="item.webUrl" target="_blank" rel="noopener noreferrer" class="partner-link">
              <div class="image-wrapper">
                <img
                  :src="item.url"
                  :alt="`友情链接-${index + 1}`"
                  :class="{ 'logo-hover': hoveredIndex === index }"
                />
                <div class="image-overlay"></div>
              </div>
            </a>
          </div>
        </div>

        <!-- 移动端横向滚动区域 -->
        <div class="connect-container mobile-scroll">
          <div class="scroll-wrapper" ref="scrollWrapper">
            <div class="scroll-track">
              <div
                class="web-box-circle"
                v-for="(item, index) in logoData"
                :key="index"
              >
                <a :href="item.webUrl" target="_blank" rel="noopener noreferrer" class="partner-link">
                  <div class="circle-wrapper">
                    <img
                      :src="item.url"
                      :alt="`友情链接-${index + 1}`"
                    />
                    <div class="circle-overlay"></div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="scroll-indicator" v-if="showScrollIndicator">
            <div class="scroll-hint">
              <i class="fas fa-chevron-left"></i>
              <span>滑动查看更多</span>
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER CENTER -->
    <div class="footer_center">
      <div class="bg-line">
        <img
          src="../assets/images/bgline.png"
          alt="装饰线条"
          srcset=""
        />
      </div>

      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-5">
            <div class="widget widget_logo">
              <div class="widget-logo" style="overflow: none; text-align: center;display: flex; align-items: center;">
                <div class="img">
                  <a href="/" aria-label="返回首页">
                    <img
                      src="../assets/images/hotel-logo01.png"
                      alt="伍號酒店logo"
                      style="transform: scale(1.5);"
                    />
                  </a>
                </div>
                <div class="text">
                  <p class="address-wrapper" @click="openMap">
                    <i class="el-icon-map-location"></i>
                    <span class="address-text" >
                      横琴粤澳深度合作区七色彩虹路1011号（天汇星影视综合城）
                    </span>
                  </p>
                  <!-- 电话号码显示 -->
                  <!-- <p class="contact-phone">
                    <i class="el-icon-phone"></i>
                    预订咨询：+853 8888 1234
                  </p> -->
                  <p class="contact-phone">
                    <i class="el-icon-phone"></i>
                    酒店电话：+86-756-3855555
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-xs-6 col-lg-3">
            <div class="widget">
              <h4 class="widget-title">网站页面</h4>
              <ul class="nav-list">
                <li><a href="/artspace" class="nav-link">艺术空间</a></li>
                <li><a href="/room" class="nav-link">酒店客房</a></li>
              </ul>
            </div>
          </div>

          <div class="col-xs-6 col-lg-4">
            <div class="widget">
              <h4 class="widget-title">关于我们</h4>
              <ul class="about-list">
                <li><a href="https://mp.weixin.qq.com/s/tLE7Dd5o0UrFUIb3YJHwmQ" target="_blank" class="nav-link">关于</a></li>
                <li><a href="/contact" class="nav-link">联系我们</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="footer_bottom">
        <div class="container">
          <p>Copyright © 2025 - 2100 HQ_Hotel5 Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "footerCom",
  data() {
    return {
      drawerVisible: false,
      hoveredIndex: -1,
      showScrollIndicator: true,
      logoData: [
        {
          url: require("@/assets/images/THX_web_logo.png"),
          webUrl: "http://www.starpeakstudios.com/",
        },
        {
          url: require("@/assets/images/ks_logo.png"),
          webUrl: "http://www.kongseng.com.mo/Ekongsengmobile/index.html",
        },
        { 
          url: require("@/assets/images/gx_real_logo.png"),
          webUrl: "http://www.starpeakstudios.com/",
        },
        {
          url: require("@/assets/images/ticket_logo.png"),
          webUrl: "https://www.macauticket.com/TicketWeb2023",
        },
        {
          url: require("@/assets/images/youxian_logo.png"),
          webUrl: "https://www.macaucabletv.com",
        },
      ],
      formData: {
        nickname: "",
        phone: "",
        email: "",
      },
    };
  },
  mounted() {
    this.initScrollHint();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    openDrawer() {
      console.log(1);
      this.drawerVisible = true;
    },
    handleLogoHover(index, isHover) {
      this.hoveredIndex = isHover ? index : -1;
    },
    handleDrawerClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
          this.formData = {
            nickname: "",
            phone: "",
            email: "",
          };
        })
        .catch(() => {});
    },
    handleFormSubmit() {
      if (!this.formData.nickname) {
        this.$message.error("请输入昵称");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.formData.phone)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        this.$message.error("请输入正确的电子邮箱");
        return;
      }

      this.$message.success("提交成功！我们会尽快联系您");
      this.drawerVisible = false;
      this.formData = {
        nickname: "",
        phone: "",
        email: "",
      };
    },
    initScrollHint() {
      const scrollWrapper = this.$refs.scrollWrapper;
      if (scrollWrapper) {
        // 检查是否需要滚动（内容宽度大于容器宽度）
        const checkScrollNeeded = () => {
          const wrapperWidth = scrollWrapper.clientWidth;
          const trackWidth = scrollWrapper.querySelector('.scroll-track')?.scrollWidth || 0;
          this.showScrollIndicator = trackWidth > wrapperWidth;
        };
        
        // 初始检查
        setTimeout(checkScrollNeeded, 100);
        
        // 监听滚动事件，滚动后隐藏提示
        scrollWrapper.addEventListener('scroll', () => {
          if (this.showScrollIndicator) {
            setTimeout(() => {
              this.showScrollIndicator = false;
            }, 1000);
          }
        });
        
        // 窗口大小改变时重新检查
        window.addEventListener('resize', checkScrollNeeded);
      }
    },
    handleResize() {
      const isMobile = window.innerWidth <= 768;
      const desktopView = document.querySelector('.desktop-view');
      const mobileScroll = document.querySelector('.mobile-scroll');
      
      if (desktopView && mobileScroll) {
        if (isMobile) {
          desktopView.style.display = 'none';
          mobileScroll.style.display = 'block';
          // 重新初始化滚动提示
          setTimeout(() => this.initScrollHint(), 100);
        } else {
          desktopView.style.display = 'flex';
          mobileScroll.style.display = 'none';
        }
      }
    },
    // 打开地图功能
    openMap() {
      // 酒店坐标（横琴粤澳深度合作区七色彩虹路1011号附近经纬度）
      const latitude = 22.12566379676462;
      const longitude = 113.52018936042093;
      const address = encodeURIComponent('横琴粤澳深度合作区七色彩虹路1011号（天汇星影视综合城）');
      
      // 检测设备平台，使用对应的地图应用
      const ua = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(ua);
      const isAndroid = /android/.test(ua);
      
      if (isIOS) {
        // iOS 使用苹果地图
        window.location.href = `http://maps.apple.com/?ll=${latitude},${longitude}&q=${address}`;
      } else if (isAndroid) {
        // Android 尝试使用高德地图或谷歌地图
        window.location.href = `https://uri.amap.com/marker?position=${longitude},${latitude}&name=${address}`;
      } else {
        // 桌面端打开高德地图网页版
        window.open(`https://www.amap.com/search?query=${address}&city=珠海`, '_blank');
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/style.css";

#footer {
  background-color: #acadb0;
  width: 100% !important;
}

.head-container {
  background-color: white;
  padding: 30px 0 0px;
  border-radius: 0 0 30px 30px;
  position: relative;
  z-index: 1000;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

  .section-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section-header {
    text-align: center;
    margin-bottom: 50px;

    .section-subtitle {
      font-size: 12px;
      letter-spacing: 3px;
      text-transform: uppercase;
      color: #b89a6e;
      font-weight: 500;
      display: inline-block;
      margin-bottom: 15px;
      position: relative;
      
      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        width: 30px;
        height: 1px;
        background: linear-gradient(90deg, transparent, #b89a6e);
      }
      
      &:before {
        right: calc(100% + 12px);
      }
      
      &:after {
        left: calc(100% + 12px);
        background: linear-gradient(90deg, #b89a6e, transparent);
      }
    }

    .section-title {
      font-size: 32px;
      font-weight: 300;
      color: #2c3e4e;
      margin-bottom: 20px;
      line-height: 1.3;
      letter-spacing: 1px;
      
      br {
        display: none;
        
        @media (max-width: 768px) {
          display: block;
        }
      }
    }

    .divider {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 15px;

      .divider-line {
        width: 60px;
        height: 1px;
        background: linear-gradient(90deg, transparent, #d4c5b0, #b89a6e, #d4c5b0, transparent);
      }

      .divider-icon {
        color: #b89a6e;
        font-size: 14px;
        animation: gentlePulse 2s ease-in-out infinite;
      }
    }
  }

  // 桌面端样式
  .connect-container.desktop-view {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 35px;

    .web-box {
      flex: 0 0 auto;
      width: 180px;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

      @media (max-width: 992px) {
        width: 150px;
      }

      .partner-link {
        display: block;
        text-decoration: none;
      }

      .image-wrapper {
        position: relative;
        background: #ffffff;
        border-radius: 20px;
        padding: 20px;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
        border: 1px solid rgba(184, 154, 110, 0.1);
        
        &:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 35px -12px rgba(0, 0, 0, 0.15);
          border-color: rgba(184, 154, 110, 0.3);
          
          .image-overlay {
            opacity: 1;
          }
        }

        img {
          width: 100%;
          height: auto;
          display: block;
          transition: all 0.3s ease;
          filter: grayscale(0%);
          
          &.logo-hover {
            transform: scale(1.05);
          }
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(circle at center, rgba(184, 154, 110, 0.08), transparent);
          border-radius: 20px;
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }
      }
    }
  }

  // 移动端横向滚动样式
  .connect-container.mobile-scroll {
    display: none;
    padding: 20px 0 30px;

    .scroll-wrapper {
      overflow-x: auto;
      overflow-y: hidden;
      scroll-behavior: smooth;
      -webkit-overflow-scrolling: touch;
      cursor: grab;
      user-select: none;
      
      &::-webkit-scrollbar {
        height: 4px;
      }
      
      &::-webkit-scrollbar-track {
        background: rgba(184, 154, 110, 0.1);
        border-radius: 4px;
      }
      
      &::-webkit-scrollbar-thumb {
        background: rgba(184, 154, 110, 0.5);
        border-radius: 4px;
        
        &:hover {
          background: rgba(184, 154, 110, 0.8);
        }
      }
      
      &:active {
        cursor: grabbing;
      }
    }

    .scroll-track {
      display: flex;
      gap: 25px;
      padding: 15px 20px;
      min-width: min-content;
    }

    .web-box-circle {
      flex: 0 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;

      .partner-link {
        display: block;
        text-decoration: none;
      }

      .circle-wrapper {
        position: relative;
        width: 120px;
        height: 120px;
        border-radius: 50%;
        background: linear-gradient(135deg, #ffffff, #f8f9fa);
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid rgba(184, 154, 110, 0.2);
        cursor: pointer;

        &:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
          border-color: rgba(184, 154, 110, 0.6);
        }

        img {
          width: 70px;
          height: 70px;
          object-fit: contain;
          transition: all 0.3s ease;
        }

        .circle-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          border-radius: 50%;
          background: radial-gradient(circle at center, rgba(184, 154, 110, 0.1), transparent);
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
        }

        &:hover .circle-overlay {
          opacity: 1;
        }
      }
    }

    .scroll-indicator {
      text-align: center;
      margin-top: 20px;
      
      .scroll-hint {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 16px;
        background: rgba(184, 154, 110, 0.1);
        border-radius: 30px;
        font-size: 12px;
        color: #b89a6e;
        animation: fadeInOut 2s ease-in-out infinite;
        
        i {
          font-size: 10px;
          
          &:first-child {
            animation: slideLeftRight 1.5s ease-in-out infinite;
          }
          
          &:last-child {
            animation: slideRightLeft 1.5s ease-in-out infinite;
          }
        }
        
        span {
          font-weight: 500;
          letter-spacing: 1px;
        }
      }
    }
  }
}

// 动画定义
@keyframes gentlePulse {
  0%, 100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

@keyframes slideLeftRight {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-3px);
  }
}

@keyframes slideRightLeft {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(3px);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.web-box {
  animation: fadeInUp 0.5s ease backwards;
  
  @for $i from 1 through 5 {
    &:nth-child(#{$i}) {
      animation-delay: #{$i * 0.08}s;
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .head-container {
    padding: 40px 0 35px;
    
    .section-header {
      margin-bottom: 35px;
      
      .section-subtitle {
        font-size: 10px;
        letter-spacing: 2px;
        
        &:before,
        &:after {
          width: 20px;
        }
      }
      
      .section-title {
        font-size: 24px;
      }
      
      .divider .divider-line {
        width: 40px;
      }
    }
    
    .connect-container.mobile-scroll {
      .web-box-circle .circle-wrapper {
        width: 100px;
        height: 100px;
        
        img {
          width: 60px;
          height: 60px;
        }
      }
      
      .scroll-track {
        gap: 20px;
        padding: 10px 15px;
      }
    }
  }
}

@media (max-width: 480px) {
  .head-container {
    .connect-container.mobile-scroll {
      .web-box-circle .circle-wrapper {
        width: 85px;
        height: 85px;
        
        img {
          width: 50px;
          height: 50px;
        }
      }
      
      .scroll-track {
        gap: 15px;
        padding: 8px 12px;
      }
    }
  }
}

// 地址样式 - 可点击并带有地图图标
.address-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 0;
  
  .lotus-icon-location {
    flex-shrink: 0;
    margin-top: 2px;
  }
  
  .address-text {
    flex: 1;
    cursor: pointer;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
    
    &:hover {
      color: #b89a6e;
      
      .map-icon {
        transform: translateX(2px);
        color: #b89a6e;
      }
    }
    
    .map-icon {
      font-size: 12px;
      color: #b89a6e;
      transition: all 0.2s ease;
      opacity: 0.8;
      
      &:hover {
        opacity: 1;
      }
    }
  }
}

// 电话号码样式
.contact-phone {
  margin-top: 8px !important;
  font-size: 14px;
  color: white;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 14px;
    color: #b89a6e;
  }
  
  &:hover {
    color: #b89a6e;
    transform: translateX(2px);
    transition: all 0.2s ease;
  }
}

// 保持原有footer样式不变
.footer_center {
  position: relative;
  overflow: hidden;

  .bg-line {
    height: 100%;
    position: absolute;
    bottom: 0;
    right: 0;

    img {
      height: 100%;
      transform: translate(40%, 0);
    }
  }
}

::v-deep {
  .el-drawer__header {
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }

  .el-drawer__title {
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }
}

.drawer-content {
  padding: 10px 0;

  .drawer-desc {
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
  }

  .sub-container {
    width: 80%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 15px;

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 5px;

      label {
        color: #333;
        font-weight: 500;
        font-size: 14px;
      }

      input {
        display: block;
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 14px;

        &:focus {
          outline: none;
          border-color: orange;
          box-shadow: 0 0 0 2px rgba(255, 165, 0, 0.1);
        }
      }
    }

    .submit-btn {
      padding: 12px;
      background-color: orange;
      color: white;
      border: none;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: background-color 0.3s ease;

      &:hover {
        background-color: #e67e22;
      }
    }
  }
}

@media (max-width: 768px) {
  .connect-container {
    width: 90%;
    margin: auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;

    .web-box {
      margin: 8px 0;
      border-radius: 20px;
      width: 120px !important;
      overflow: hidden;
      cursor: pointer;
      box-shadow: 6px 4px 5px 0px gray;

      &:hover {
        img {
          transform: scale(1.1);
          transition: 0.2s linear;
        }
      }
    }
  }
  
  .address-wrapper .address-text {
    font-size: 12px;
  }
}

a {
  text-decoration: none !important;
  transition: all 0.3s ease;
}

.footer_bottom,
.footer_top {
  background-color: #acadb0 !important;
}

.widget {
  .widget-title {
    color: white !important;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid orange;
    display: inline-block;
  }

  .nav-list,
  .about-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav-link {
    color: white !important;
    transition: all 0.3s ease;

    &:hover {
      color: orange !important;
      padding-left: 5px;
    }
  }

  .contact-us-btn {
    transition: color 0.3s ease;

    &:hover {
      color: orange !important;
    }
  }
}

.widget-logo .text p a {
  color: white;

  &:hover {
    color: orange;
    text-decoration: underline;
  }
}

.footer_bottom p {
  text-align: center;
  color: white;
  margin: 0;
  font-size: 14px;
}
</style>